import { PostContent } from "../../../content/post/postList";
import { Layout } from "../../../layout/page";

export function PostList() {
  return (
    <Layout>
      <PostContent />
    </Layout>
  );
}
